import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "../utils";
import { FieldWrapper } from "./field-wrapper";

type TextareaFieldProps = {
  label?: string;
  helperText?: string;
  error?: string;
  className?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextareaField = forwardRef<
  HTMLTextAreaElement,
  TextareaFieldProps
>(({ label, helperText, error, className, id, ...props }, ref) => {
  const fieldId =
    id || `textarea-${label?.toLowerCase().replace(/\s+/g, "-") || "field"}`;

  const textarea = (
    <textarea
      ref={ref}
      id={fieldId}
      className={cn(
        "block w-full rounded-md bg-white px-3 py-2 text-sm text-slate-900",
        "border border-slate-300 placeholder:text-slate-400",
        "focus:outline-none focus:ring-2 focus:ring-default-500 focus:border-default-500",
        "disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed",
        "resize-y min-h-[80px]",
        error && "border-red-500",
        className,
      )}
      {...props}
    />
  );

  if (!label && !helperText && !error) {
    return textarea;
  }

  return (
    <FieldWrapper
      label={label}
      helperText={helperText}
      error={error}
      id={fieldId}
    >
      {textarea}
    </FieldWrapper>
  );
});

TextareaField.displayName = "TextareaField";
